import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformfeature() {
  return (
    <section className="platform_feature p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/moodbe/features.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={887}
                height={950}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Platform <span style={{ color: "#5A67FF" }}>Features</span>
            </h2>
            <p>
              MoodBe has some exciting features for users to get a seamless
              dating app experience. The app has a ‘social sign-in’ feature,
              making it easy for users to sign up and login using their existing
              social media accounts. The ‘create a date’ feature allows users to
              schedule dates with their matches, including booking restaurants
              directly from the app. It also features ‘Yelp integration’,
              providing users access to millions of restaurant reviews from real
              customers, so that you can find the perfect restaurant for your
              date. MoodBe also offers a ‘swipe left and right feature’, for
              users to easily accept or reject potential matches.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
